import { defineStore } from 'pinia'

type netParems = {
  [key: string]: any
}
export const useNetInfoStore = defineStore('net', {
  state: () => ({
    data: {} as netParems
  }),
  getters: {
    getNetInfo: (state) => state.data
  },
  actions: {
    setNetInfo(params: netParems) {
      this.data = params
    }
  },
  persist: {
    storage: localStorage
  }
})
